import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Hidden,
  IconButton,
  withStyles,
  Grid,
  Box,
} from "@material-ui/core";
import NavigationDrawer from "../../../shared/components/NavigationDrawer";
import { getInitials } from "../../../shared/functions/strings";
import { useDispatch, useSelector } from "react-redux";
import { history } from "./../../../App";
import HenigMenuIcon from "./../../../shared/components/Henig/MenuIcon";
import ConditionalWrapper from './../../../shared/components/ConditionalWrapper';
import { TTIcon, FBIcon, LIIcon } from './../../../shared/components/SocialIcons';
import SearchBar from "material-ui-search-bar";
import smoothScrollTop from "shared/functions/smoothScrollTop";
import isDarkModeOn from '../../../shared/functions/dark';

const StyledSearchBar = styled(SearchBar)`
    width: 174px;
    height: 30px;
    margin-left: right;
    background: transparent;
    border-bottom: 1px solid white;
    border-radius: 0;
    margin-top: 20px;
    
    input{
      font-family: Lato;
      font-size: 17px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: left;
      color: #ffffff;
    }
    button{
      color: #7f8489;
      padding-right: 6px;
    }
    & > div{
      margin-left: 0;
      margin-right: auto;
      width: auto;
    }
    svg{
      height: 17px;
    }

    @media (max-width: 600px){
      width: auto;
    }
`;



const NavButton = ({ element, className, classes, onClick }) => {

  return <ConditionalWrapper
    condition={element.link}
    wrapper={children => <Link key={element.name} to={element.link} className={classes.noDecoration} onClick={onClick}>{children}</Link>}
  >
    <Button
      onClick={element.onClick}
      className={className}
      key={element.name}
    >
      {element.icon && element.iconInNavBar && element.icon}
      {element.name}
    </Button>
  </ConditionalWrapper>;
}

const StyledNavButton = styled(NavButton)`
  height: 30px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 8.93;
  letter-spacing: 0.56px;
  text-align: left;
  color: #b6b8bc;
  margin-right: 10px;
  margin-left: 10px;
  overflow: hidden;
`;

const UserInitialsIcon = styled.span`
  width: 24px;
  height: 24px;
  background-color: #24272b;
  border-radius: 50%;
  margin-right: 8px;
  margin-top: 2px;

  font-family: Lato;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #b08f6e;
`;

const HenigLogoImg = styled.img`
  height: ${props => props.isBright ? '94%' : '46px'};
  position: absolute;
  left: 50%;
  top: ${props => props.isBright ? '2px' : '6px'};
  transform: translateX(-50%);
`;
const HenigLogo = (props) => (
  <HenigLogoImg isBright={props.isBright} {...props} src={props.isBright ? '/images/henig-logo-white-small.jpg' : '/images/logo@3x.png'} />
);

const styles = (theme) => ({
  appBar: {
    boxShadow: 'none', // theme.shadows[6],
    //backgroundColor: theme.palette.common.blackNight,
    //color: theme.palette.common.blackNight,
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuButtonText: {
    //fontSize: theme.typography.body1.fontSize,
    fontSize: '1rem',
    fontWeight: theme.typography.h6.fontWeight,
    marginRight: 20,
  },
  brandText: {
    fontFamily: "'Roboto",
    fontWeight: 300,
  },
  noDecoration: {
    textDecoration: "none !important",
  },
});

function NavBar(props) {
  let {
    classes,
    openEmailDialog,
    handleMobileDrawerOpen,
    handleMobileDrawerClose,
    mobileDrawerOpen,
    selectedTab,
    showNavBar,
    scrollTop,
    isBright,
  } = props;

  if(isDarkModeOn()){
    isBright = false;
  }

  const isAuthorised = useSelector((state) => state.auth.isAuthorised);
  const authUser = useSelector((state) => state.auth.user);
  const fxrates = useSelector((state) => state.site.fxrates) || [];

  const [searchValue, setSearchValue] = React.useState('');

  let drawerMenuItems = [
    {
      name: <StyledSearchBar
        placeholder={'Search'}
        value={searchValue}
        onChange={(newValue) => setSearchValue(newValue)}
        onRequestSearch={(newValue) => {
          handleMobileDrawerClose()
          setMenuOpen(false)
          history.push(`/news?keywords=${newValue}`)
          setSearchValue('')
        }}
      />
    },
    {
      separator: true,
    },
    {
      link: "/diamonds/all",
      name: "All Diamonds",
      icon: <img alt="" src={'/images/all.svg'} />,
    },
    {
      link: "/diamonds/fav",
      name: "Favourite",
      icon: <img alt="" src={'/images/fav.svg'} />,
    },
    {
      link: "/diamonds/compare",
      name: "Compare List",
      icon: <img alt="" src={'/images/compare.svg'} />,
    },
    {
      link: "/diamonds/bag",
      name: "Your Bag",
      icon: <img alt="" src={'/images/bag.svg'} />,
    },
    {
      separator: true,
    },
  ];


  if (!isAuthorised) {
    drawerMenuItems.push({
      name: "Account",
      onClick: () => openEmailDialog(),
      icon: <img alt="" src="/images/not-loggin-user.svg" />,
    });
  } else {
    drawerMenuItems.push({
      name: authUser && authUser.role === 'user' ? "Account" : "Admin",
      onClick: () => authUser && history.push(authUser.role === 'user' ? "/my-account" : '/admin'),
      icon: <UserInitialsIcon>{authUser && getInitials(authUser.firstName + ' ' + (authUser.lastName || ''))}</UserInitialsIcon>,
    });
  }


  drawerMenuItems = [...drawerMenuItems,
  {
    separator: true,
  },
  {
    link: "/",
    name: "Home",
  },
  {
    link: "/about-us",
    name: "About Us",
  },
  {
    link: "/api",
    name: "Api",
  },
  {
    link: "/contact-us",
    name: "Contact Us",
  },
  {
    link: "/news",
    name: "News",
  },
  {
    link: "/faqs",
    name: "Faqs",
  },
  {
    separator: true,
  },
  {
    name: <Box>
      <Grid container spacing={4} alignItems="center">
        <Grid item>
          <a href="/">
            <FBIcon />
          </a>
        </Grid>
        <Grid item>
          <a href="/">
            <TTIcon />
          </a>
        </Grid>
        <Grid item>
          <a href="/">
            <LIIcon />
          </a>
        </Grid>
      </Grid>
    </Box>
  }
  ];

  const menuItemsLeft = [
    {
      link: "/diamonds/all",
      name: "Diamonds",
    },
    {
      // link: "/jewellery",
      name: "Jewellery",
      onClick: () => {
        document.location.href = 'https://jewellery.henigdiamonds.co.uk/'
      },
    },
  ];

  let menuItemsRight = [
    /* {
      link: "/",
      name: "Home",
      icon: <HomeIcon className="text-white" />
    },
    {
      link: "/news",
      name: "Blog",
      icon: <BookIcon className="text-white" />
    }, */
  ];

  const userCurrencies = authUser && authUser.Balances ? authUser.Balances.reduce((userBalances, balance) => {
    Object.keys(balance).forEach(ccyCode => {
        userBalances[ccyCode] = balance[ccyCode];
    })
    return userBalances;
}, []) : []
  let currencies = Object.keys(userCurrencies);
  let defaultCurrency = '';

  if (selectedTab) {
    const defaultFXRate = fxrates.find(c => c.default);
    if (defaultFXRate) {
      defaultCurrency = defaultFXRate.currency;
    }
  }

  if (!isAuthorised) {
    menuItemsRight.push({
      name: "Account",
      onClick: openEmailDialog,
      icon: <UserInitialsIcon>
        <img alt="" src="/images/not-loggin-user.svg" />
      </UserInitialsIcon>,
      iconInNavBar: true,
    });
  } else {
    menuItemsRight.push({
      name: "Account",
      onClick: () => authUser && history.push(authUser.role === 'user' ? "/my-account" : '/admin'),
      icon: <UserInitialsIcon>{authUser && getInitials(authUser.firstName + ' ' + (authUser.lastName || ''))}</UserInitialsIcon>,
      iconInNavBar: true,
    });
  }

  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleMobileDrawerCloseDo = (e, isOpen) => {
    setMenuOpen(isOpen || false);
    if (!isOpen) handleMobileDrawerClose();
  }


  const [showNavBarOnScroll, setShowNavBarOnScroll] = React.useState(false);
  React.useEffect(() => {
    function handleScroll() {
      let myScrollTop = window.scrollY || scrollTop;
      if (myScrollTop > 760) setShowNavBarOnScroll(true);
      if (myScrollTop < 760) setShowNavBarOnScroll(false);
    };

    if (scrollTop) {
      handleScroll();
    } else {
      window.addEventListener('scroll', handleScroll);
    }

    return function cleanup() {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  return (
    <div className={classes.root}>
      <AppBar position="fixed" className={classes.appBar} style={{ backgroundColor: isBright ? 'white' : 'black', color: '#b6b8bc', transitionProperty: 'opacity', transitionDuration: '1.5s', opacity: showNavBar || showNavBarOnScroll ? (isBright ? 1 : 0.9) : 0 }}>
        <Toolbar className={classes.toolbar}>

          <div>

            <IconButton
              className={classes.menuButton}
              onClick={handleMobileDrawerOpen}
              aria-label="Open Navigation"
            >
              <HenigMenuIcon menuOpen={menuOpen} onOpen={() => handleMobileDrawerCloseDo(false, true)} isBright={isBright} />
              {/* <MenuIcon color="primary" /> */}
            </IconButton>

            <Hidden smDown>
              {menuItemsLeft.map((element, i) => <StyledNavButton key={i} element={element} classes={classes} onClick={handleMobileDrawerCloseDo} />)}
            </Hidden>
          </div>

          <Link to="/" className={classes.noDecoration} onClick={() => {
            const welcomeEl =  document.getElementById('welcome');
            if(welcomeEl){
              document.getElementById('welcome').scrollIntoView({
                behavior: 'smooth', // smooth scroll
                block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
              })
            }
          }}>
            <HenigLogo isBright={isBright} />
          </Link>

          <div>

            <Hidden smDown>
              {menuItemsRight.map((element, i) => <StyledNavButton key={i} element={element} classes={classes} onClick={handleMobileDrawerCloseDo} />)}
            </Hidden>
          </div>
        </Toolbar>
      </AppBar>
      <NavigationDrawer
        paperTransparent
        menuItems={drawerMenuItems}
        anchor="left"
        open={mobileDrawerOpen}
        selectedItem={selectedTab}
        onClose={handleMobileDrawerCloseDo}
        isBright={isBright}
      />
    </div>
  );
}

export default withStyles(styles, { withTheme: true })(NavBar);
